import _ from 'lodash';
import Immutable from 'immutable';
import Cookies from 'js-cookie';
import { Howler } from 'howler';

import ActionTypes from '../constants/ActionTypes';
import scenesData from '../data/scenes.json';

const interactionsCompleted = {};
let scenesCompleted = Cookies.getJSON('scenescompleted');

if (typeof scenesCompleted === 'undefined') {
    scenesCompleted = {};
    _.each(scenesData, (scene) => {
        scenesCompleted[scene.name] = false;
    });
    Cookies.set('scenescompleted', scenesCompleted);
}
Cookies.set('scenescompleted', {});


// let cookieVolume = parseFloat(Cookies.get('volume'));
//
// if (typeof cookieVolume === 'undefined') {
//     cookieVolume = 0.5;
//     Cookies.set('volume', cookieVolume);
// }
//
// console.log(cookieVolume);
// Howler.volume(cookieVolume);

/* var interactionsCompleted = Cookies.getJSON('interactionscompleted');
if (typeof interactionsCompleted === 'undefined')
{
    interactionsCompleted = {};
    Cookies.set('interactionscompleted', interactionsCompleted);
} */
// scenesCompleted.oligarchie = false;// TMP


const initialState = {
    playing: true,
    // Dynamic values
    skipIntro: false, // Change this when you r developing something else
    learnMoreOpened: false,
    learnMoreContent: {
        key: null,
    },
    learnMoreKey: '',
    pageKey: null,
    sceneKey: null,
    scenesCompleted,
    interactionsCompleted,
    language: 'fr',
    messageBoxPlaying: true,
    framesDone: {

    },

    // Menu
    headerAppearance: 'full',
    menuOpen: false,
    soundBarOpen: false,
    masterVolume: parseFloat(0.5),

    // Static values
    debug: false,
    originalWidth: 1080,
    originalHeight: 1920,
    cleanTint: 0x20cf66,
    dirtyTints: [
        0xff3333,
        0xff9900,
    ],
};

function completeScene(state, sceneKey) {
    const sc = _.clone(state.get('scenesCompleted'));
    sc[sceneKey] = true;

    Cookies.set('scenescompleted', sc);
    return state.set('scenesCompleted', sc);
}

function updateInteraction(state, key, value) {
    const ic = _.clone(state.get('interactionsCompleted'));
    ic[key] = value;

    Cookies.set('interactionscompleted', ic);
    return state.set('interactionsCompleted', ic);
}

function setLanguage(state, value) {
    Cookies.set('language', value);
    return state.set('language', value);
}

module.exports = (oldState, action) => {
    let state = oldState;
    if (typeof oldState === 'undefined') {
        const language = Cookies.get('language');
        initialState.language = language;
        state = Immutable.Map(initialState);
    }

    switch (action.type) {
    case ActionTypes.SET_PLAYING:
        return state.set('playing', action.payload.playing);
    case ActionTypes.SET_PAGE:
        return state.set('pageKey', action.payload.pageKey);
    case ActionTypes.SET_SCENE:
        if (action.payload.sceneKey) {
            return state.set('sceneKey', action.payload.sceneKey);
        }
        return state;
    case ActionTypes.SET_FRAME_DONE:
        if (action.payload.sceneKey) {
            const framesDone = state.get('framesDone');
            if (!framesDone[action.payload.sceneKey]) {
                framesDone[action.payload.sceneKey] = {};
            }
            framesDone[action.payload.sceneKey][action.payload.index] = true;
            // console.log('NOW', framesDone);
            return state.set('framesDone', framesDone);
        }
        return state;
    case ActionTypes.SET_HEADER_APPEARANCE:
        return state.set('headerAppearance', action.payload.headerAppearance);
    case ActionTypes.SET_MENU_OPEN:
        // console.log('menuOpen', action.payload.menuOpen);
        return state.set('menuOpen', action.payload.menuOpen);
    case ActionTypes.SET_SOUND_BAR_OPEN:
        return state.set('soundBarOpen', action.payload.soundBarOpen);
    case ActionTypes.SET_MASTER_VOLUME:
        // console.log('the master volume', action.payload.masterVolume);
        const volume = action.payload.masterVolume;
        if (volume) {
            Howler.volume(volume);
        } else {
            Howler.volume(0);
        }
        Cookies.set('volume', volume);
        return state.set('masterVolume', volume);
    case ActionTypes.SET_MESSAGE_BOX_PLAYING:
        return state.set('messageBoxPlaying', action.payload.playing);
    case ActionTypes.SET_LANGUAGE:
        return setLanguage(state, action.payload.language);
    case ActionTypes.COMPLETE_SCENE:
        return completeScene(state, action.payload.sceneKey);
    case ActionTypes.COMPLETE_INTERACTION:
        return updateInteraction(state, action.payload, true);
    case ActionTypes.UNCOMPLETE_INTERACTION:
        return updateInteraction(state, action.payload, false);
    case ActionTypes.UPDATE_SKIP_INTRO:
        return state.set('skipIntro', false);
    case ActionTypes.LEARN_MORE_CHANGE:
        return state
            .set('learnMoreOpened', action.payload.opened)
            .set('learnMoreKey', action.payload.key)
            .set('learnMoreContent', action.payload.content ?
                action.payload.content : state.get('learnMoreContent'));
    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./js/stores/StageStore.js